export const PRICE_LIST_URLS = {
  CREATE: "/price_list/create",
  GET: "/price_list/get",
  LIST: "/price_list/list",
  UPDATE: "/price_list/update",
};

export const PRICE_LIST_RECORD_URLS = {
  LIST: "/price_list_record/list",
  GET: "/price_list_record/get",
};

export const PRICE_LIST_FILE_MAPPINGS_URLS = {
  GET: "/price_list_file_mappings/get",
};

export enum URL {
  HOME = "/",
};
